function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M79.2463 20C79.2463 19.77 79.1862 19.54 79.06 19.3375L73 9.64125V2.5C73 1.80875 72.44 1.25 71.75 1.25H44.25C43.56 1.25 43 1.80875 43 2.5V9.53L34.56 19.1775C34.3563 19.4088 34.2625 19.7025 34.2625 20H34.25V28.9438C33.4275 28.8263 32.595 28.75 31.75 28.75C25.8525 28.75 20.3775 31.68 17.1062 36.5875L15.4925 39.0088C10.1288 40.1038 1.75 42.5988 1.75 47.5C1.75 56.3975 6.21 64.2612 13 69.0112V70C13 74.9875 21.0613 78.75 31.75 78.75H65.5C65.7363 78.75 65.9437 78.6675 66.1325 78.5537L66.1438 78.5725L71.75 75.2075L77.3562 78.5713C77.555 78.69 77.7775 78.75 78 78.75C78.2125 78.75 78.425 78.6963 78.6162 78.5875C79.0075 78.365 79.25 77.95 79.25 77.5V20H79.2463ZM75.745 18.75H67.755L71.75 12.3588L75.745 18.75ZM70.5 73.0425L66.75 75.2925V21.25H70.5V73.0425ZM45.5 3.75H70.5V8.75H45.5V3.75ZM19.1863 37.9738C21.9937 33.7637 26.69 31.25 31.75 31.25C36.81 31.25 41.5062 33.7637 44.3137 37.9738L53.5662 51.8525C48.835 53.6187 41.3325 55 31.75 55C22.1675 55 14.665 53.6187 9.93375 51.8525L19.1863 37.9738ZM55.89 50.8313L50.025 42.0325C56.3713 43.6662 59.25 45.8725 59.25 47.5C59.25 48.5425 58.0662 49.7213 55.89 50.8313ZM59.25 43.28C56.345 41.0537 51.5138 39.7238 48.0075 39.0075L46.3937 36.5875C45.1388 34.7038 43.5537 33.12 41.75 31.8725V31.25H59.25V43.28ZM13.475 42.0337L7.61 50.8313C5.43375 49.7213 4.25 48.5425 4.25 47.5C4.25 45.8713 7.13125 43.6662 13.475 42.0337ZM4.6925 52.01C9.86 55.6 21.0487 57.5 31.75 57.5C42.4512 57.5 53.64 55.6 58.8075 52.01C56.6937 62.955 47.0525 71.25 35.5 71.25H28C16.4475 71.25 6.80625 62.9538 4.6925 52.01ZM15.6062 70.63C19.3013 72.6175 23.52 73.75 28 73.75H35.5C39.98 73.75 44.1987 72.6175 47.8938 70.63C47.035 73.405 40.6512 76.25 31.75 76.25C22.8488 76.25 16.465 73.405 15.6062 70.63ZM64.25 76.25H45.1225C48.48 74.6862 50.5 72.4962 50.5 70V69.0112C57.29 64.2612 61.75 56.3975 61.75 47.5V30C61.75 29.3088 61.19 28.75 60.5 28.75H40.5C39.81 28.75 39.25 29.3088 39.25 30V30.4575C38.4425 30.0762 37.61 29.7563 36.75 29.5012V21.25H64.25V76.25ZM38.255 18.75L44.8175 11.25H69.495L64.8075 18.75H38.255ZM73 73.0425V21.25H76.75V75.2913L73 73.0425Z",
  fill: "#E77F67"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 36.25H38V38.75H35.5V36.25Z",
  fill: "#E77F67"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23 40H25.5V42.5H23V40Z",
  fill: "#E77F67"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5 47.5H33V50H30.5V47.5Z",
  fill: "#E77F67"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M41.75 45H44.25V47.5H41.75V45Z",
  fill: "#E77F67"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.75 47.5H19.25V50H16.75V47.5Z",
  fill: "#E77F67"
});

var SvgIngredients = function SvgIngredients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIngredients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ingredients.d0bb566f.svg";
export { ForwardRef as ReactComponent };